"use client";
import { useItemListing } from "./ItemListingContext";

type Template = `${string}${"{numberOfHits}" | "{query}"}${string}` | string;

export type NumberOfHitsProps = {
  nbHits?: number;
  query?: string;
  template: Template;
  blankQuery?: Template;
  noHits?: Template;
};

export function NumberOfHits({
  nbHits: nbHitsProp,
  query: queryProp,
  template,
  blankQuery,
  noHits,
}: NumberOfHitsProps) {
  const ctx = useItemListing();
  const nbHits = nbHitsProp ?? ctx.nbHits;
  const query = queryProp ?? ctx.search.query ?? "";

  return getNumberOfHitsText({ nbHits, query, template, blankQuery, noHits });
}

export function getNumberOfHitsText({
  nbHits: nbHitsProp,
  query: queryProp,
  template,
  blankQuery,
  noHits,
}: NumberOfHitsProps) {
  const nbHits = nbHitsProp;
  const query = queryProp ?? "";

  if (blankQuery && !query)
    return blankQuery
      .replace("{numberOfHits}", `${nbHits}`)
      .replace("{query}", `${query}`);
  if (noHits && nbHits === 0)
    return noHits
      .replace("{numberOfHits}", `${nbHits}`)
      .replace("{query}", `${query}`);
  return template
    .replace("{numberOfHits}", `${nbHits}`)
    .replace("{query}", `${query}`);
}
